import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GungBase } from 'gung-standard';
import { Observable, ReplaySubject, Subject, map } from 'rxjs';

export interface ColmecDiscount {
  agreementId: string;
  supplierName: string;
  discountPercentage: number;
}

export interface ImportResponse extends GungBase {
  message: string;
  step: string;
  level: string;
}

@Injectable({
  providedIn: 'root'
})
export class ColmecDiscountsService {
  protected discountListInitialized = false;
  protected discountListSubject: Subject<ColmecDiscount[]> = new ReplaySubject<ColmecDiscount[]>();
  protected discountListObservable: Observable<ColmecDiscount[]> = this.discountListSubject.asObservable();

  url = 'json/colmec-discounts';

  constructor(protected http: HttpClient) {}

  getColmecDiscountsServer(): Observable<ColmecDiscount[]> {
    const headers: { [s: string]: string | string[] } = {};
    headers.maxAge = '-1';
    return this.http.get<ColmecDiscount[]>(this.url, { headers });
  }

  getColmecDiscounts(): Observable<ColmecDiscount[]> {
    if (!this.discountListInitialized) {
      this.updateDiscountListSubject();
    }

    return this.discountListSubject;
  }

  updateDiscountListSubject() {
    this.getColmecDiscountsServer().subscribe(discounts => {
      this.discountListSubject.next(discounts);
      this.discountListInitialized = true;
    });
  }

  import(formData: FormData): Observable<ImportResponse> {
    const url = 'json/colmec-discount/excel/import?file';
    return this.http.post<ImportResponse>(url, formData);
  }

  export(): Observable<any> {
    const url = 'json/colmec-discount/excel/export';
    return this.http
      .get(url, {
        responseType: 'arraybuffer',
        observe: 'response'
      })
      .pipe(
        map((response: HttpResponse<ArrayBuffer>) => {
          const contentDispositionHeader: string | null = response.headers.get('Content-Disposition');
          let filename = 'export-discounts.xlsx';
          if (contentDispositionHeader) {
            const matches = /filename="?([^"]+)"?;/i.exec(contentDispositionHeader);
            if (matches && matches.length > 1) {
              filename = matches[1];
            }
          }
          const blob = new Blob([response.body], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const downloadUrl = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          }, 100);
        })
      );
  }
}
